"use client";

import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";

interface OtpStepProps {
  className?: string;
  cooldown: number;
  email: string;
  isSending: boolean;
  isVerifying: boolean;
  onChangeEmail: () => void;
  onResend: () => void;
  onTokenChange: (value: string) => void;
  signingInMessage: string;
  token: string;
  verifyError: string | null;
}

export function OtpStep({
  className,
  email,
  token,
  isVerifying,
  isSending,
  cooldown,
  verifyError,
  signingInMessage,
  onTokenChange,
  onResend,
  onChangeEmail,
}: OtpStepProps) {
  let resendLabel: string;
  if (isSending) {
    resendLabel = "Sending…";
  } else if (cooldown > 0) {
    resendLabel = `Resend in ${cooldown}s`;
  } else {
    resendLabel = "Resend code";
  }

  return (
    <div className={className}>
      <Card className="ring-0">
        <CardHeader>
          <CardTitle className="text-2xl">Check your email</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-muted-foreground text-sm">
            We sent a 6-digit code to <strong>{email}</strong>. It expires in 1
            hour.
          </p>
          <div className="flex flex-col gap-3">
            <InputOTP
              className="w-full"
              disabled={isVerifying}
              maxLength={6}
              onChange={onTokenChange}
              value={token}
            >
              <InputOTPGroup className="w-full">
                <InputOTPSlot className="h-12 flex-1" index={0} />
                <InputOTPSlot className="h-12 flex-1" index={1} />
                <InputOTPSlot className="h-12 flex-1" index={2} />
                <InputOTPSlot className="h-12 flex-1" index={3} />
                <InputOTPSlot className="h-12 flex-1" index={4} />
                <InputOTPSlot className="h-12 flex-1" index={5} />
              </InputOTPGroup>
            </InputOTP>
            <div className="min-h-5 text-center">
              {isVerifying && (
                <p className="text-muted-foreground text-sm">
                  {signingInMessage}
                </p>
              )}
              {verifyError && (
                <p className="text-destructive text-sm">{verifyError}</p>
              )}
            </div>
          </div>
          <Button
            disabled={cooldown > 0 || isSending}
            onClick={onResend}
            variant="outline"
          >
            {resendLabel}
          </Button>
          <Button onClick={onChangeEmail} variant="ghost">
            Change email
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
